export const mainServices = [
  {
    id: 1,
    mediaUrl: "service1.mp4",
    mediaType: "video",
    title: "INTERIOR MAIN CONTRACTOR SERVICE",
    desc: "Interior Main Contractor Service | Interior Commercial Retails Fit Out Service | Interior Renovation service | Interior Custom Fittings firm | Interior Retails Maintenance Service | Interior Retails Rectification Work",
  },
  {
    id: 2,
    mediaUrl: "retail&mallMaintenance/header_1.jpg",
    mediaType: "image",
    title: "RETAILS & MALLS MAINENANCE SERVICE",
    desc: "Managing and maintaining the infrastructure, facilities, and services within retail complexes and shopping malls to ensure safety, quality, and functionality.",
  },
  {
    id: 3,
    mediaUrl: "service3.mp4",
    mediaType: "video",
    title: "INTERIOR CONSULTANT SERVICE",
    desc: "Expert guidance on optimizing space, style, and decor to create functional, appealing interiors tailored to client preferences.",
  },
  {
    id: 4,
    mediaUrl: "cat2.mp4",
    mediaType: "video",
    title: "ENDORSEMENT & DOCUMENTATION SERVICE",
    desc: "Detailed approvals and documentation to ensure the compliance of design plans meet regulatory standards and requirements.",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    videoBg: "cat1.mp4",
    title: "DESIGN ONLY",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    videoBg: "cat2.mp4",
    title: "DESIGN & BUILD",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    videoBg: "cat3.mp4",
    title: "BUILD ONLY",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id: 2,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id: 3,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
  },
  {
    id: 4,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 5,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id: 6,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 7,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 8,
    img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
  },
];

export const portfolioItems = [
  {
    id: 1,
    service: "LUXE PROJECTS",
    portfolioInfo: [
      {
        id: 1,
        image: "portfolios/ushiraku/img_1.jpg",
        title: "Ushiraku Yakiniku",
        subTitle: "Jalan Telawi 3, Bangsar",
        portfolioName: "F&B-Ushiraku Yakiniku Bangsar",
        name: "Ushiraku Yakiniku Bangsar",
        type: "F&B",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Jalan Telawi 3, Bangsar",
        imageOne: "ushiraku/img_1.jpg",
        imageTwo: "ushiraku/img_2.jpg",
        imageThree: "ushiraku/img_3.jpg",
        imageFour: "ushiraku/img_4.jpg",
        imageFive: "ushiraku/img_5.jpg",
        imageSix: "ushiraku/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Ushiraku Yakiniku",
            image: "ushiraku/img_1.jpg",
          },
          {
            id: 2,
            category: "Ushiraku Yakiniku",
            image: "ushiraku/img_2.jpg",
          },
          {
            id: 3,
            category: "Ushiraku Yakiniku",
            image: "ushiraku/img_3.jpg",
          },
          {
            id: 4,
            category: "Ushiraku Yakiniku",
            image: "ushiraku/img_4.jpg",
          },
          {
            id: 5,
            category: "Ushiraku Yakiniku",
            image: "ushiraku/img_5.jpg",
          },
          {
            id: 6,
            category: "Ushiraku Yakiniku",
            image: "ushiraku/img_6.jpg",
          },
        ],
      },
      {
        id: 2,
        image: "portfolios/lesNereidesParis/img_1.jpg",
        title: "Les Nereides Paris",
        subTitle: "Pavilion, Kuala Lumpur",
        portfolioName: "Retails Outlet-Les Nereides Paris Pavilion",
        name: "Les Nereides Paris Pavilion",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Pavilion, Kuala Lumpur",
        imageOne: "lesNereidesParis/img_1.jpg",
        imageTwo: "lesNereidesParis/img_2.jpg",
        imageThree: "lesNereidesParis/img_3.jpg",
        imageFour: "lesNereidesParis/img_4.jpg",
        imageFive: "lesNereidesParis/img_5.jpg",
        imageSix: "lesNereidesParis/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Les Nereides Paris",
            image: "lesNereidesParis/img_1.jpg",
          },
          {
            id: 2,
            category: "Les Nereides Paris",
            image: "lesNereidesParis/img_2.jpg",
          },
          {
            id: 3,
            category: "Les Nereides Paris",
            image: "lesNereidesParis/img_3.jpg",
          },
          {
            id: 4,
            category: "Les Nereides Paris",
            image: "lesNereidesParis/img_4.jpg",
          },
          {
            id: 5,
            category: "Les Nereides Paris",
            image: "lesNereidesParis/img_5.jpg",
          },
          {
            id: 6,
            category: "Les Nereides Paris",
            image: "lesNereidesParis/img_6.jpg",
          },
        ],
      },
      {
        id: 3,
        image: "portfolios/cyclelogy/img_1.jpg",
        title: "Cyclelogy PJ",
        subTitle: "PJ Jaya One, Retails Outlet",
        portfolioName: "Retails Outlet-Cyclelogy PJ Jaya One",
        name: "Cyclelogy PJ Jaya One",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "PJ Jaya One",
        imageOne: "cyclelogy/img_1.jpg",
        imageTwo: "cyclelogy/img_2.jpg",
        imageThree: "cyclelogy/img_3.jpg",
        imageFour: "cyclelogy/img_4.jpg",
        imageFive: "cyclelogy/img_5.jpg",
        imageSix: "cyclelogy/img_6.jpg",
        // serviceList: [
        //   { service: "Furniture" },
        //   { service: "Furniture" },
        //   { service: "Furniture" },
        //   { service: "Furniture" },
        // ],
        secondaryImageList: [
          {
            id: 1,
            category: "Cyclelogy PJ",
            image: "cyclelogy/img_1.jpg",
          },
          {
            id: 2,
            category: "Cyclelogy PJ",
            image: "cyclelogy/img_2.jpg",
          },
          {
            id: 3,
            category: "Cyclelogy PJ",
            image: "cyclelogy/img_3.jpg",
          },
          {
            id: 4,
            category: "Cyclelogy PJ",
            image: "cyclelogy/img_4.jpg",
          },
          {
            id: 5,
            category: "Cyclelogy PJ",
            image: "cyclelogy/img_5.jpg",
          },
          {
            id: 6,
            category: "Cyclelogy PJ",
            image: "cyclelogy/img_6.jpg",
          },
        ],
      },
      {
        id: 4,
        image: "portfolios/gazebo&TopG/img_1.jpg",
        title: "Gazebo & TOP G Coffee",
        subTitle: "Publika Shopping Gallery, Solaris Dutamas",
        portfolioName: "Retails Outlet-Gazebo & TOP G Coffee Publika",
        name: "Gazebo & TOP G Coffee",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Solaris Dutamas",
        imageOne: "gazebo&TopG/img_1.jpg",
        imageTwo: "gazebo&TopG/img_2.jpg",
        imageThree: "gazebo&TopG/img_3.jpg",
        imageFour: "gazebo&TopG/img_4.jpg",
        imageFive: "gazebo&TopG/img_5.jpg",
        imageSix: "gazebo&TopG/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Gazebo & TOP G Coffee",
            image: "gazebo&TopG/img_1.jpg",
          },
          {
            id: 2,
            category: "Gazebo & TOP G Coffee",
            image: "gazebo&TopG/img_2.jpg",
          },
          {
            id: 3,
            category: "Gazebo & TOP G Coffee",
            image: "gazebo&TopG/img_3.jpg",
          },
          {
            id: 4,
            category: "Gazebo & TOP G Coffee",
            image: "gazebo&TopG/img_4.jpg",
          },
          {
            id: 5,
            category: "Gazebo & TOP G Coffee",
            image: "gazebo&TopG/img_5.jpg",
          },
          {
            id: 6,
            category: "Gazebo & TOP G Coffee",
            image: "gazebo&TopG/img_6.jpg",
          },
        ],
      },
      {
        id: 5,
        image: "portfolios/cyclelogyJohor/img_1.jpg",
        title: "Cyclelogy Johor",
        subTitle: "Johor Bahru, Johor",
        portfolioName: "Retails Outlet-Cyclelogy Johor Bahru",
        name: "Cyclelogy Johor Bahru",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Johor Bahru, Johor",
        imageOne: "cyclelogyJohor/img_1.jpg",
        imageTwo: "cyclelogyJohor/img_2.jpg",
        imageThree: "cyclelogyJohor/img_3.jpg",
        imageFour: "cyclelogyJohor/img_4.jpg",
        imageFive: "cyclelogyJohor/img_5.jpg",
        imageSix: "cyclelogyJohor/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Cyclelogy Johor",
            image: "cyclelogyJohor/img_1.jpg",
          },
          {
            id: 2,
            category: "Cyclelogy Johor",
            image: "cyclelogyJohor/img_2.jpg",
          },
          {
            id: 3,
            category: "Cyclelogy Johor",
            image: "cyclelogyJohor/img_3.jpg",
          },
          {
            id: 4,
            category: "Cyclelogy Johor",
            image: "cyclelogyJohor/img_4.jpg",
          },
          {
            id: 5,
            category: "Cyclelogy Johor",
            image: "cyclelogyJohor/img_5.jpg",
          },
          {
            id: 6,
            category: "Cyclelogy Johor",
            image: "cyclelogyJohor/img_6.jpg",
          },
        ],
      },
      {
        id: 6,
        image: "portfolios/lamarsa/img_1.png",
        title: "Lamarsa Coffee",
        subTitle: "Coffee Machine Company, Sunway Damansara",
        portfolioName: "Retails Outlet-Lamarsa Coffee Machine Company",
        name: "Lamarsa Coffee Machine Company",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Sunway Damansara, Petaling Jaya",
        imageOne: "lamarsa/img_1.png",
        imageTwo: "lamarsa/img_2.jpg",
        imageThree: "lamarsa/img_3.jpg",
        imageFour: "lamarsa/img_4.png",
        imageFive: "lamarsa/img_5.png",
        imageSix: "lamarsa/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Lamarsa Coffee",
            image: "lamarsa/img_1.png",
          },
          {
            id: 2,
            category: "Lamarsa Coffee",
            image: "lamarsa/img_2.jpg",
          },
          {
            id: 3,
            category: "Lamarsa Coffee",
            image: "lamarsa/img_3.jpg",
          },
          {
            id: 4,
            category: "Lamarsa Coffee",
            image: "lamarsa/img_4.png",
          },
          {
            id: 5,
            category: "Lamarsa Coffee",
            image: "lamarsa/img_5.png",
          },
          {
            id: 6,
            category: "Lamarsa Coffee",
            image: "lamarsa/img_6.jpg",
          },
        ],
      },
      {
        id: 7,
        image: "portfolios/clubClio/img_1.jpg",
        title: "CLUB CLIO",
        subTitle: "Sunway Pyramid, Petaling Jaya",
        portfolioName: "Retails Outlet-CLUB CLIO Sunway Pyramid",
        name: "CLUB CLIO Sunway Pyramid",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Sunway Pyramid, Petaling Jaya",
        imageOne: "clubClio/img_1.jpg",
        imageTwo: "clubClio/img_2.jpg",
        imageThree: "clubClio/img_3.jpg",
        imageFour: "clubClio/img_4.jpg",
        imageFive: "clubClio/img_5.jpg",
        imageSix: "clubClio/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "CLUB CLIO",
            image: "clubClio/img_1.jpg",
          },
          {
            id: 2,
            category: "CLUB CLIO",
            image: "clubClio/img_2.jpg",
          },
          {
            id: 3,
            category: "CLUB CLIO",
            image: "clubClio/img_3.jpg",
          },
          {
            id: 4,
            category: "CLUB CLIO",
            image: "clubClio/img_4.jpg",
          },
          {
            id: 5,
            category: "CLUB CLIO",
            image: "clubClio/img_5.jpg",
          },
          {
            id: 6,
            category: "CLUB CLIO",
            image: "clubClio/img_6.jpg",
          },
        ],
      },
      {
        id: 8,
        image: "portfolios/banilaCo/img_1.jpg",
        title: "Banila Co",
        subTitle: "Pavilion, Kuala Lumpur",
        portfolioName: "Retails Outlet-Banila Co Pavilion",
        name: "Banila Co Pavilion",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Pavilion, Kuala Lumpur",
        imageOne: "banilaCo/img_1.jpg",
        imageTwo: "banilaCo/img_2.jpg",
        imageThree: "banilaCo/img_3.jpg",
        imageFour: "banilaCo/img_4.jpg",
        imageFive: "banilaCo/img_5.jpg",
        imageSix: "banilaCo/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Banila Co",
            image: "banilaCo/img_1.jpg",
          },
          {
            id: 2,
            category: "Banila Co",
            image: "banilaCo/img_2.jpg",
          },
          {
            id: 3,
            category: "Banila Co",
            image: "banilaCo/img_3.jpg",
          },
          {
            id: 4,
            category: "Banila Co",
            image: "banilaCo/img_4.jpg",
          },
          {
            id: 5,
            category: "Banila Co",
            image: "banilaCo/img_5.jpg",
          },
          {
            id: 6,
            category: "Banila Co",
            image: "banilaCo/img_6.jpg",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    service: "LUXE PROJECTS",
    portfolioInfo: [
      {
        id: 9,
        image: "portfolios/specializedBangsar/img_1.png",
        title: "Specialized Bangsar",
        subTitle: "Concept Store Lorong Maarof, Bangsar",
        portfolioName: "Retails Outlet-Specialized Concept Store Bangsar",
        name: "Specialized Concept Store Bangsar",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Lorong Maarof, Bangsar",
        imageOne: "specializedBangsar/img_1.png",
        imageTwo: "specializedBangsar/img_2.png",
        imageThree: "specializedBangsar/img_3.png",
        imageFour: "specializedBangsar/img_4.png",
        imageFive: "specializedBangsar/img_5.png",
        imageSix: "specializedBangsar/img_6.png",
        secondaryImageList: [
          {
            id: 1,
            category: "Specialized Bangsar",
            image: "specializedBangsar/img_1.png",
          },
          {
            id: 2,
            category: "Specialized Bangsar",
            image: "specializedBangsar/img_2.png",
          },
          {
            id: 3,
            category: "Specialized Bangsar",
            image: "specializedBangsar/img_3.png",
          },
          {
            id: 4,
            category: "Specialized Bangsar",
            image: "specializedBangsar/img_4.png",
          },
          {
            id: 5,
            category: "Specialized Bangsar",
            image: "specializedBangsar/img_5.png",
          },
          {
            id: 6,
            category: "Specialized Bangsar",
            image: "specializedBangsar/img_6.png",
          },
        ],
      },
      {
        id: 10,
        image: "portfolios/ksl/img_1.jpg",
        title: "KSL Hotel",
        subTitle: "Hotel Banquet Hall",
        portfolioName: "Hotel-KSL Hotel Banquet Hall",
        name: "Hotel-KSL Hotel Banquet Hall",
        type: "Hotel",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "",
        imageOne: "ksl/img_1.jpg",
        imageTwo: "ksl/img_2.jpg",
        imageThree: "ksl/img_3.jpg",
        imageFour: "ksl/img_4.jpg",
        imageFive: "ksl/img_5.jpg",
        imageSix: "ksl/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "KSL Hotel",
            image: "ksl/img_1.jpg",
          },
          {
            id: 2,
            category: "KSL Hotel",
            image: "ksl/img_2.jpg",
          },
          {
            id: 3,
            category: "KSL Hotel",
            image: "ksl/img_3.jpg",
          },
          {
            id: 4,
            category: "KSL Hotel",
            image: "ksl/img_4.jpg",
          },
          {
            id: 5,
            category: "KSL Hotel",
            image: "ksl/img_5.jpg",
          },
          {
            id: 6,
            category: "KSL Hotel",
            image: "ksl/img_6.jpg",
          },
        ],
      },
      {
        id: 11,
        image: "portfolios/getha/img_2.jpg",
        title: "Getha Aeon Nilai",
        subTitle: "Concept Store Aeon Nilai, Negeri Sembilan",
        portfolioName: "Retails Outlet-Getha Concept Store Aeon Nilai",
        name: "Getha Concept Store Aeon Nilai",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Nilai, Negeri Sembilan",
        imageOne: "getha/img_2.jpg",
        imageTwo: "getha/img_1.png",
        imageThree: "getha/img_3.png",
        imageFour: "getha/img_4.png",
        imageFive: "getha/img_5.png",
        imageSix: "getha/img_6.png",
        secondaryImageList: [
          {
            id: 1,
            category: "Getha",
            image: "getha/img_2.jpg",
          },
          {
            id: 2,
            category: "Getha",
            image: "getha/img_1.png",
          },
          {
            id: 3,
            category: "Getha",
            image: "getha/img_3.png",
          },
          {
            id: 4,
            category: "Getha",
            image: "getha/img_4.png",
          },
          {
            id: 5,
            category: "Getha",
            image: "getha/img_5.png",
          },
          {
            id: 6,
            category: "Getha",
            image: "getha/img_6.png",
          },
        ],
      },
      {
        id: 12,
        image: "portfolios/love&Co/img_1.png",
        title: "Love & Co. KL",
        subTitle: "Retails Outlet, Kuala Lumpur",
        portfolioName: "Retails Outlet - Love & Co.",
        name: "Love & Co. KL",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Kuala Lumpur",
        imageOne: "love&Co/img_1.png",
        imageTwo: "love&Co/img_2.png",
        imageThree: "love&Co/img_3.png",
        imageFour: "love&Co/img_4.jpg",
        imageFive: "love&Co/img_5.jpg",
        imageSix: "love&Co/img_6.png",
        secondaryImageList: [
          {
            id: 1,
            category: "Love & Co.",
            image: "love&Co/img_1.png",
          },
          {
            id: 2,
            category: "Love & Co.",
            image: "love&Co/img_2.png",
          },
          {
            id: 3,
            category: "Love & Co.",
            image: "love&Co/img_3.png",
          },
          {
            id: 4,
            category: "Love & Co.",
            image: "love&Co/img_4.jpg",
          },
          {
            id: 5,
            category: "Love & Co.",
            image: "love&Co/img_5.jpg",
          },
          {
            id: 6,
            category: "Love & Co.",
            image: "love&Co/img_6.png",
          },
        ],
      },
      {
        id: 13,
        image: "portfolios/usagencyWatch/img_1.jpg",
        title: "Usagency Watch",
        subTitle: "Pavilion, Kuala Lumpur",
        portfolioName: "Retails Outlet-Usagency Watch Pavilion",
        name: "Usagency Watch Pavilion",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Pavilion, Kuala Lumpur",
        imageOne: "usagencyWatch/img_1.jpg",
        imageTwo: "usagencyWatch/img_2.jpg",
        imageThree: "usagencyWatch/img_3.jpg",
        imageFour: null,
        imageFive: null,
        imageSix: null,
        secondaryImageList: [
          {
            id: 1,
            category: "Usagency Watch",
            image: "usagencyWatch/img_1.jpg",
          },
          {
            id: 2,
            category: "Usagency Watch",
            image: "usagencyWatch/img_2.jpg",
          },
          {
            id: 3,
            category: "Usagency Watch",
            image: "usagencyWatch/img_3.jpg",
          },
        ],
      },
      {
        id: 14,
        image: "portfolios/cyclelogyBangsar/img_1.jpg",
        title: "Cyclelogy Bangsar",
        subTitle: "Lorong Maarof Bangsar",
        portfolioName: "Retails Outlet-Cyclelogy Bangsar",
        name: "Cyclelogy Lorong Maarof Bangsar",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Lorong Maarof Bangsar",
        imageOne: "cyclelogyBangsar/img_1.jpg",
        imageTwo: "cyclelogyBangsar/img_2.jpg",
        imageThree: "cyclelogyBangsar/img_3.jpg",
        imageFour: "cyclelogyBangsar/img_4.jpg",
        imageFive: "cyclelogyBangsar/img_5.jpg",
        imageSix: "cyclelogyBangsar/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Cyclelogy Bangsar",
            image: "cyclelogyBangsar/img_1.jpg",
          },
          {
            id: 2,
            category: "Cyclelogy Bangsar",
            image: "cyclelogyBangsar/img_2.jpg",
          },
          {
            id: 3,
            category: "Cyclelogy Bangsar",
            image: "cyclelogyBangsar/img_3.jpg",
          },
          {
            id: 4,
            category: "Cyclelogy Bangsar",
            image: "cyclelogyBangsar/img_4.jpg",
          },
          {
            id: 5,
            category: "Cyclelogy Bangsar",
            image: "cyclelogyBangsar/img_5.jpg",
          },
          {
            id: 6,
            category: "Cyclelogy Bangsar",
            image: "cyclelogyBangsar/img_6.jpg",
          },
        ],
      },
      {
        id: 15,
        image: "portfolios/sightCity/img_4.jpg",
        title: "Sight City Seremban",
        subTitle: "Seremban 2, Negeri Sembilan",
        portfolioName: "Retails Outlet-Sight City Seremban",
        name: "Sight City",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Seremban 2, Negeri Sembilan",
        imageOne: "sightCity/img_1.jpg",
        imageTwo: "sightCity/img_2.jpg",
        imageThree: "sightCity/img_3.jpg",
        imageFour: "sightCity/img_4.jpg",
        imageFive: "sightCity/img_5.jpg",
        imageSix: "sightCity/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Sight City",
            image: "sightCity/img_1.jpg",
          },
          {
            id: 2,
            category: "Sight City",
            image: "sightCity/img_2.jpg",
          },
          {
            id: 3,
            category: "Sight City",
            image: "sightCity/img_3.jpg",
          },
          {
            id: 4,
            category: "Sight City",
            image: "sightCity/img_4.jpg",
          },
          {
            id: 5,
            category: "Sight City",
            image: "sightCity/img_5.jpg",
          },
          {
            id: 6,
            category: "Sight City",
            image: "sightCity/img_6.jpg",
          },
        ],
      },
      {
        id: 16,
        image: "portfolios/pdcmc/img_1.jpg",
        title: "PDCMC",
        subTitle: "Kpg Bahasa Kapor, Port Dickson",
        portfolioName: "Church-PDCMC Multi Function Hall",
        name: "PDCMC Multi Function Hall",
        type: "Church",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Kpg Bahasa Kapor, Port Dickson",
        imageOne: "pdcmc/img_1.jpg",
        imageTwo: "pdcmc/img_2.jpg",
        imageThree: "pdcmc/img_3.jpg",
        imageFour: "pdcmc/img_4.jpg",
        imageFive: "pdcmc/img_5.jpg",
        imageSix: "pdcmc/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "PDCMC",
            image: "pdcmc/img_1.jpg",
          },
          {
            id: 2,
            category: "PDCMC",
            image: "pdcmc/img_2.jpg",
          },
          {
            id: 3,
            category: "PDCMC",
            image: "pdcmc/img_3.jpg",
          },
          {
            id: 4,
            category: "PDCMC",
            image: "pdcmc/img_4.jpg",
          },
          {
            id: 5,
            category: "PDCMC",
            image: "pdcmc/img_5.jpg",
          },
          {
            id: 6,
            category: "PDCMC",
            image: "pdcmc/img_6.jpg",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    service: "LUXE PROJECTS",
    portfolioInfo: [
      {
        id: 17,
        image: "portfolios/kronoz/img_1.jpg",
        title: "Kronoz Jeans Fahrenheit",
        subTitle: "Retails Outlet, Kuala Lumpur",
        portfolioName: "Retails Outlet-Kronoz Jeans Fahrenheit KL",
        name: "Kronoz Jeans Fahrenheit KL",
        type: "Retails Outlet",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Kuala Lumpur",
        imageOne: "kronoz/img_1.jpg",
        imageTwo: "kronoz/img_2.jpg",
        imageThree: "kronoz/img_3.jpg",
        imageFour: "kronoz/img_4.jpg",
        imageFive: "kronoz/img_5.jpg",
        imageSix: "kronoz/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Kronoz Jeans Fahrenheit",
            image: "kronoz/img_1.jpg",
          },
          {
            id: 2,
            category: "Kronoz Jeans Fahrenheit",
            image: "kronoz/img_2.jpg",
          },
          {
            id: 3,
            category: "Kronoz Jeans Fahrenheit",
            image: "kronoz/img_3.jpg",
          },
          {
            id: 4,
            category: "Kronoz Jeans Fahrenheit",
            image: "kronoz/img_4.jpg",
          },
          {
            id: 5,
            category: "Kronoz Jeans Fahrenheit",
            image: "kronoz/img_5.jpg",
          },
          {
            id: 6,
            category: "Kronoz Jeans Fahrenheit",
            image: "kronoz/img_6.jpg",
          },
        ],
      },
      {
        id: 18,
        image: "portfolios/gardenResidence/img_1.jpg",
        title: "Garden Residence Cyberjaya",
        subTitle: "Cyberjaya, Selangor",
        portfolioName: "Semi D-Garden Residence Cyberjaya",
        name: "Garden Residence Cyberjaya",
        type: "Semi Detached",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Cyberjaya, Selangor",
        imageOne: "gardenResidence/img_1.jpg",
        imageTwo: "gardenResidence/img_2.jpg",
        imageThree: "gardenResidence/img_3.jpg",
        imageFour: "gardenResidence/img_4.jpg",
        imageFive: "gardenResidence/img_5.jpg",
        imageSix: "gardenResidence/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Garden Residence",
            image: "gardenResidence/img_1.jpg",
          },
          {
            id: 2,
            category: "Garden Residence",
            image: "gardenResidence/img_2.jpg",
          },
          {
            id: 3,
            category: "Garden Residence",
            image: "gardenResidence/img_3.jpg",
          },
          {
            id: 4,
            category: "Garden Residence",
            image: "gardenResidence/img_4.jpg",
          },
          {
            id: 5,
            category: "Garden Residence",
            image: "gardenResidence/img_5.jpg",
          },
          {
            id: 6,
            category: "Garden Residence",
            image: "gardenResidence/img_6.jpg",
          },
        ],
      },
      {
        id: 19,
        image: "portfolios/bungalowPJ/img_1.png",
        title: "Residence Bungalow",
        subTitle: "Kuala Lumpur",
        portfolioName: "Residence-Bungalow Kuala Lumpur",
        name: "Bungalow Kuala Lumpur",
        type: "Residence",
        service: "Luxe Main Contractor Service, Interior Design Service",
        location: "Kuala Lumpur",
        imageOne: "bungalowPJ/img_1.png",
        imageTwo: "bungalowPJ/img_2.jpg",
        imageThree: "bungalowPJ/img_3.jpg",
        imageFour: "bungalowPJ/img_4.jpg",
        imageFive: "bungalowPJ/img_5.jpg",
        imageSix: "bungalowPJ/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "BUNGALOW KL",
            image: "bungalowPJ/img_1.png",
          },
          {
            id: 2,
            category: "BUNGALOW KL",
            image: "bungalowPJ/img_2.jpg",
          },
          {
            id: 3,
            category: "BUNGALOW KL",
            image: "bungalowPJ/img_3.jpg",
          },
          {
            id: 4,
            category: "BUNGALOW KL",
            image: "bungalowPJ/img_4.jpg",
          },
          {
            id: 5,
            category: "BUNGALOW KL",
            image: "bungalowPJ/img_5.jpg",
          },
          {
            id: 6,
            category: "BUNGALOW KL",
            image: "bungalowPJ/img_6.jpg",
          },
        ],
      },
      {
        id: 20,
        image: null,
        title: null,
        subTitle: null,
        portfolioName: null,
        name: null,
        type: null,
        service: null,
        location: null,
        imageOne: null,
        imageTwo: null,
        imageThree: null,
        imageFour: null,
        imageFive: null,
        imageSix: null,
        secondaryImageList: null,
      },
      {
        id: 21,
        image: null,
        title: null,
        subTitle: null,
        portfolioName: null,
        name: null,
        type: null,
        service: null,
        location: null,
        imageOne: null,
        imageTwo: null,
        imageThree: null,
        imageFour: null,
        imageFive: null,
        imageSix: null,
        secondaryImageList: null,
      },
      {
        id: 23,
        image: null,
        title: null,
        subTitle: null,
        portfolioName: null,
        name: null,
        type: null,
        service: null,
        location: null,
        imageOne: null,
        imageTwo: null,
        imageThree: null,
        imageFour: null,
        imageFive: null,
        imageSix: null,
        secondaryImageList: null,
      },
      {
        id: 24,
        image: null,
        title: null,
        subTitle: null,
        portfolioName: null,
        name: null,
        type: null,
        service: null,
        location: null,
        imageOne: null,
        imageTwo: null,
        imageThree: null,
        imageFour: null,
        imageFive: null,
        imageSix: null,
        secondaryImageList: null,
      },
      {
        id: 22,
        image: null,
        title: null,
        subTitle: null,
        portfolioName: null,
        name: null,
        type: null,
        service: null,
        location: null,
        imageOne: null,
        imageTwo: null,
        imageThree: null,
        imageFour: null,
        imageFive: null,
        imageSix: null,
        secondaryImageList: null,
      },
    ],
  },
  {
    id: 4,
    service: "LUXE RETAIL MAINTENANCE",
    portfolioInfo: [
      {
        id: 21,
        image: "portfolios/sephora/img_1.jpg",
        title: "Sephora Malaysia",
        subTitle: "Mall Outlets, Kuala Lumpur",
        portfolioName: "Retails Outlet-Sephora Kuala Lumpur, Malaysia",
        name: "Sephora Kuala Lumpur, Malaysia",
        type: "Retails Outlet",
        service: "Retails & Malls Maintenance Service",
        location: "Kuala Lumpur",
        imageOne: "sephora/img_1.jpg",
        imageTwo: "sephora/img_2.jpg",
        imageThree: "sephora/img_3.jpg",
        imageFour: "sephora/img_4.jpg",
        imageFive: "sephora/img_5.jpg",
        imageSix: "sephora/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Sephora",
            image: "sephora/img_1.jpg",
          },
          {
            id: 2,
            category: "Sephora",
            image: "sephora/img_2.jpg",
          },
          {
            id: 3,
            category: "Sephora",
            image: "sephora/img_3.jpg",
          },
          {
            id: 4,
            category: "Sephora",
            image: "sephora/img_4.jpg",
          },
          {
            id: 5,
            category: "Sephora",
            image: "sephora/img_5.jpg",
          },
          {
            id: 6,
            category: "Sephora",
            image: "sephora/img_6.jpg",
          },
        ],
      },
      {
        id: 22,
        image: "portfolios/prada/img_1.jpg",
        title: "Prada Malaysia",
        subTitle: "Mall Outlets, Kuala Lumpur",
        portfolioName: "Retails Outlet-Prada Kuala Lumpur, Malaysia",
        name: "Prada Kuala Lumpur, Malaysia",
        type: "Retails Outlet",
        service: "Retails & Malls Maintenance Service",
        location: "Kuala Lumpur",
        imageOne: "prada/img_1.jpg",
        imageTwo: "prada/img_2.jpg",
        imageThree: "prada/img_3.jpeg",
        imageFour: "prada/img_4.jpg",
        imageFive: "prada/img_5.jpg",
        imageSix: "prada/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Prada",
            image: "prada/img_1.jpg",
          },
          {
            id: 2,
            category: "Prada",
            image: "prada/img_2.jpg",
          },
          {
            id: 3,
            category: "Prada",
            image: "prada/img_3.jpeg",
          },
          {
            id: 4,
            category: "Prada",
            image: "prada/img_4.jpg",
          },
          {
            id: 5,
            category: "Prada",
            image: "prada/img_5.jpg",
          },
          {
            id: 6,
            category: "Prada",
            image: "prada/img_6.jpg",
          },
        ],
      },
      {
        id: 23,
        image: "portfolios/miumiu/img_2.jpg",
        title: "Miu Miu Malaysia",
        subTitle: "Mall Outlets, Kuala Lumpur",
        portfolioName: "Retails Outlet-Miu Miu Kuala Lumpur, Malaysia",
        name: "Miu Miu Kuala Lumpur, Malaysia",
        type: "Retails Outlet",
        service: "Retails & Malls Maintenance Service",
        location: "Kuala Lumpur",
        imageOne: "miumiu/img_1.jpg",
        imageTwo: "miumiu/img_2.jpg",
        imageThree: "miumiu/img_3.jpg",
        imageFour: "miumiu/img_4.jpg",
        imageFive: "miumiu/img_5.jpg",
        imageSix: "miumiu/img_6.jpg",
        secondaryImageList: [
          {
            id: 1,
            category: "Miu Miu",
            image: "miumiu/img_2.jpg",
          },
          {
            id: 2,
            category: "Miu Miu",
            image: "miumiu/img_1.jpg",
          },
          {
            id: 3,
            category: "Miu Miu",
            image: "miumiu/img_3.jpg",
          },
          {
            id: 4,
            category: "Miu Miu",
            image: "miumiu/img_4.jpg",
          },
          {
            id: 5,
            category: "Miu Miu",
            image: "miumiu/img_5.jpg",
          },
          {
            id: 6,
            category: "Miu Miu",
            image: "miumiu/img_6.jpg",
          },
        ],
      },
      {
        id: 24,
        image: null,
        title: null,
        subTitle: null,
        portfolioName: null,
        name: null,
        type: null,
        service: null,
        location: null,
        imageOne: null,
        imageTwo: null,
        imageThree: null,
        imageFour: null,
        imageFive: null,
        imageSix: null,
        secondaryImageList: null,
      },
    ],
  },
];

export const services = [
  {
    id: 1,
    title: null,
    description: null,
    serviceImg: null,
    services: null,
    unqiueService: null,
  },
  {
    id: 2,
    title: "Retails & Malls Maintenance Service",
    description:
      "Maintenance for retail stores and malls involves various tasks to ensure the premises are safe and fully operational. It is crucial for ensuring smooth operations, enhancing customer experiences, and preserving the long-term value of the property.",
    serviceImg: "retail&mallMaintenance/header_2.jpg",
    services: [
      {
        img: "retail&mallMaintenance/img_1.jpg",
        title: "Luxe Interior Maintenance",
        desc: "•  HVAC system maintenance to ensure comfortable indoor temperatures and air quality. \n\n•  Electrical and lighting system checking to ensure proper functionality and safety. <Roller>Plumbing and restroom maintenance to prevent leaks and ensure sanitary. \n\n•  Furniture and fixture maintenance and repair. \n\n•  Roller Shutter emergency service.",
      },
    ],
    unqiueService: {
      img: "retail&mallMaintenance/unique.jpg",
      title: "Maintenance Categories",
      description:
        "<b>Luxe Preventive maintenance</b> \nRegularly scheduled maintenance to prevent breakdowns and equipment failures. \n\n<b>Luxe Corrective maintenance</b> \nRepairing equipment or systems after they have failed. \n\n<b>Luxe Predictive maintenance</b> \nUsing data and analytics to predict when equipment is likely to fail and schedule maintenance accordingly. \n\n<b>Luxe Emergency maintenance</b> \nResponding to unexpected breakdowns or failures.",
    },
  },
  {
    id: 3,
    title: "Interior Consultant Service",
    description:
      "The specific content of working drawings may vary depending on the project's complexity and the requirements of local building codes and regulations. It is essential to ensure that the drawings are complete, accurate, and up-to-date to avoid delays and costly errors during construction.",
    serviceImg: "interiorConsultant/header_1.jpg",
    services: [
      {
        img: "interiorConsultant/img_1.jpg",
        title: "Initial Consultation and Assessment",
        desc: "<b>Needs Analysis</b> \nUnderstanding your lifestyle, preferences, and goals for the space. \n\n<b>Space Evaluation</b> \nAssessing the existing layout, features, and potential.",
      },
      {
        img: "interiorConsultant/img_2.jfif",
        title: "Design Planning",
        desc: "<b>Concept Development</b> \nCreating design ideas based on your input and the space's characteristics. \n\n<b>Floor Plans and Layouts</b> \nDesigning efficient and functional arrangements. \n\n<b>Material Selection</b> \nChoosing finishes, colors, and textures that align with your vision. \n\n<b>Furniture and Furnishings</b> \nSuggesting suitable pieces and accessories.",
      },
      {
        img: "interiorConsultant/img_3.jpg",
        title: "Visualizations",
        desc: "<b>Renderings and Mood Boards</b> \nPresenting visual representations of the proposed design. \n\n<b>3D Modeling</b> \nCreating detailed 3D models for a more immersive experience.",
      },
    ],
    unqiueService: {
      img: "interiorConsultant/unique.jpg",
      title: "Full Packed Working Drawings",
      description:
        "Full-packed working drawings are essential for ensuring that all stakeholders have a clear understanding of the project, minimizing errors, and facilitating effective communication between designers, contractors, and clients.\n\n<li><b>Interior 3D Conceptual Perspective Drawings</b></li>\t-  3D rendering visualizes drawings \n\t-  3D modelling \n\n<li><b>Interior Architecture Working Drawings</b></li>\t-  Proposed conceptual layout plan\n\t-  Furniture layout plan\n\t-  M&E layout plan\n\t-  Demolition plan\n\t-  Reflected ceiling plan \n\t-  Power & Switches plan\n\t-  Floor finishes plan\n\t-  Wall & Partition finishes plan\n\t-  Lighting fixture drawings\n\t-  Loose furniture drawings\n\t-  Doors & Windows finishes specifications\n\t-  Floor finishes specifications\n\t-  Wall finishes specifications\n\t-  Lightings fixture specifications\n\t-  FCU layout plan\n\t-  As built drawings\n\n\t<b>Final Documentation</b> \n\tUpdated drawings reflecting any changes made. \n\n<li><b>Interior Technical Drawings</b></li>\t-  Joinery details drawings\n\t-  Sectional details drawings\n\t-  Elevation drawings\n\t-  Façade & Feature details drawings \n\n<b>Digital Files</b> \nThe specific content of working drawings may vary depending on the project's complexity and the requirements of local building codes and regulations. It is essential to ensure that the drawings are complete, accurate, and up-to-date to avoid delays and costly errors during construction. \n\n<b>CAD (Computer-Aided Design) Files</b>\nElectronic versions of the drawings for editing and sharing. \n\n<b>PDF (Portable Document Format) files</b>\nRead-only versions of the drawings for distribution and review",
    },
  },
  {
    id: 4,
    title: "Interior Endorsement & Documentation Service",
    description:
      "Interior endorsement and documentation services are essential for ensuring the accuracy, completeness, and compliance of interior design projects.",
    serviceImg: "endorsement&documentation/header_1.png",
    services: [
      {
        img: "endorsement&documentation/img_1.jpg",
        title: "Endorsement",
        desc: "<b>Verification of Design Compliance</b> \nConfirming that the design aligns with applicable building codes, regulations, and standards. \n\n<b>Material Approval</b> \nEnsuring that materials used in the project meet required specifications and quality standards. \n\n<b>Construction Oversight</b> \nMonitoring the construction process to verify adherence to design plans and specifications.",
      },
      {
        img: "endorsement&documentation/img_2.jpg",
        title: "Documentation",
        desc: "<b>Design Drawings and Specifications</b> \nPreparing and managing detailed drawings, plans, and specifications for the project. \n\n<b>Material Samples and Specifications</b> \nCollecting and organizing samples of materials and finishes used in the project.\n\n<b>Construction Documentation</b> \nRecording and documenting the construction process including progress photos, meeting minutes etc. \n\n<b>As-Built Drawings</b> \nCreating final drawings that reflect the actual construction of the project.",
      },
    ],
    unqiueService: {
      img: "endorsement&documentation/unique.jpg",
      title: null,
      description:
        "\n<li><b>Malls & Retails Design, \n     Private buildings & Land develop submission</b></li> <li><b>DBKL, MBPJ, MBSJ licensing \n     Local Perancang Tanah etc.</b></li> <li><b>Professional IR Endorsement:</b></li>\t-  Structural drawings, \n\t-  Sprinkle drawings\n\t-  Electrical single line diagram\n\t-  Borong G,H,Q,N \n\t-  Plumbing single line \n\t-  Kitchen exhaust plan\n\t-  Grease interceptor plan\n\t-  Signage visual\n\t-  CHWP schematic diagram air-conditional",
    },
  },
];

export const mainContractorServices = {
  title: "Interior Main Contractor Service",
  description:
    "This service consist of <b>Interior Commercial Retails Fit out service</b>, <b>Interior Retails Maintenance service</b> and <b>Interior Renovation service</b>. \n\n-  Project schedule & timeline \n-  Project weekly report \n-  Project site protection & safety\n-  Project supervises\n-  Sub- contractors’ coordination \n-  Working Permit application & submission\n-  Project Inspection & defect touch up\n-  Project handover \n\nLuxe main contractor services specializes in comprehensive interior renovations, guiding clients from consultation to project completion. We collaborate with architects and designers to create tailored solutions, managing all aspects including permits, demolition, structural changes, and installations. Our focus on quality ensures that every detail meets high standards, culminating in a final walkthrough to guarantee client satisfaction. At Luxe Design Firm, we deliver exceptional results that reflect our clients' unique styles and needs.",
  serviceImg: "header.jpg",
  workList: [
    {
      id: 1,
      portfolioInfo: [
        {
          id: 1,
          image: "services/mainContractor/interior3d.jpg",
          title:
            "Luxe Interior 3d Conceptual Perspective Drawings 3d Rendering Visualizes 3d Modelling ",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 2,
          image: "services/mainContractor/designCoordination.jpg",
          title:
            "Luxe Design Coordination Team C/W Technical Design Support And Design Refinement",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 3,
          image: "services/mainContractor/interiorProfessional.jpg",
          title:
            "Luxe Interior Professional Engineer Endorsement & Documentation Service",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 4,
          image: "services/mainContractor/interiorTechnical.jpg",
          title: "Luxe Interior Technical Drawings",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 5,
          image: "services/mainContractor/interiorArchitecture.jpg",
          title: "Luxe Interior Architecture Working Drawings",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 6,
          image: "services/mainContractor/demolitionWork.jpg",
          title: "Luxe Demolition Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 7,
          image: "services/mainContractor/reinstatementWork.jpg",
          title: "Luxe Retails Reinstatement Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 8,
          image: "services/mainContractor/customJoinery.jpg",
          title: "Luxe Custom Joinery Work/Carpentry Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
      ],
    },
    {
      id: 2,
      portfolioInfo: [
        {
          id: 9,
          image: "services/mainContractor/customGlazing.jpg",
          title: "Luxe Custom Glazing Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 10,
          image: "services/mainContractor/m&e.jpg",
          title: "Luxe Mechanical and Electrical Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 11,
          image: "services/mainContractor/roofingWork.jpg",
          title: "Luxe Roofing Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 12,
          image: "services/mainContractor/customMetal.jpg",
          title: "Luxe Interior Custom Metal And Steel Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 13,
          image: "services/mainContractor/stainlessSteel.jpg",
          title: "Luxe Stainless Steel - PVD Titanium Coating Service",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 14,
          image: "services/mainContractor/interiorFlooring.jpg",
          title: "Luxe Interior Flooring Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 15,
          image: "services/mainContractor/exteriorFlooring.jpg",
          title: "Luxe Exterior Flooring Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 16,
          image: "services/mainContractor/waterProofing.jpg",
          title: "Luxe Waterproofing Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
      ],
    },
    {
      id: 3,
      portfolioInfo: [
        {
          id: 17,
          image: "services/mainContractor/customAir.jpg",
          title: "Luxe Custom Air Conditional Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 18,
          image: "services/mainContractor/cusomFreshAir.jpg",
          title: "Luxe Custom Fresh Air Systems Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 19,
          image: "services/mainContractor/tilingWork.jpg",
          title: "Luxe Tiling Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 20,
          image: "services/mainContractor/paintingWork.jpg",
          title: "Luxe Painting Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 21,
          image: "services/mainContractor/sprayPaint.jpg",
          title: "Luxe Spray Paint Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 22,
          image: "services/mainContractor/sandSpray.jpg",
          title: "Luxe Sand Spray Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 23,
          image: "services/mainContractor/plasterCeiling.jpg",
          title: "Luxe Plaster Ceiling Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 24,
          image: "services/mainContractor/cementWork.jpg",
          title: " Luxe Cement Works",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
      ],
    },
    {
      id: 4,
      portfolioInfo: [
        {
          id: 25,
          image: "services/mainContractor/plumbingWork.jpg",
          title: "Luxe Plumbing Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 26,
          image: "services/mainContractor/kitchenSpecialists.jpg",
          title: "Luxe Kitchen Specialists And Suppliers",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 27,
          image: "services/mainContractor/exhaustHood.jpg",
          title: "Luxe Exhaust Hood System And Ducting Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 28,
          image: "services/mainContractor/retails&malls.jpg",
          title: "Luxe Retails And Malls Maintenance Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 29,
          image: "services/mainContractor/acrylicDetails.jpg",
          title: "Luxe Acrylic Details Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 30,
          image: "services/mainContractor/illuminationSignage.jpg",
          title: "Luxe Illumination Signage Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 31,
          image: "services/mainContractor/aluminumWork.jpg",
          title: "Luxe Custom Aluminium Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 32,
          image: "services/mainContractor/facade.jpg",
          title: "Luxe Retail Facade Structure Specialized",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
      ],
    },
    {
      id: 5,
      portfolioInfo: [
        {
          id: 33,
          image: "services/mainContractor/rollerShutte.jpg",
          title: "Luxe Custom Motorize Retail Roller- Shuttle",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 34,
          image: "services/mainContractor/rollerBlinds.jpg",
          title: "Luxe Custom Motorize Outdoor/Indoor Roller-blinds",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 35,
          image: "services/mainContractor/fireSprinkler.jpg",
          title: "Luxe Fire-sprinkler Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 36,
          image: "services/mainContractor/fireExtinguisher.jpg",
          title: "Luxe Fire Extinguisher Supply And Renewal Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 37,
          image: "services/mainContractor/submission.jpg",
          title:
            "Luxe Malls & Retails Design, Private Buildings & Land Develop Submission Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 38,
          image: "services/mainContractor/dbkl.jpg",
          title:
            "Luxe DBKL,MBPJ, MBSJ ETC. Licensing - Local PERANCANG Tanah Etc. Submission Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 39,
          image: "services/mainContractor/electricalSingleLine.jpg",
          title:
            "Luxe Electrical Single Line Diagram Submission Borong G,H,Q,N",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 40,
          image: "services/mainContractor/gasPiping.jpg",
          title: "Luxe Gas Pipe Plumbing System",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
      ],
    },
    {
      id: 6,
      portfolioInfo: [
        {
          id: 41,
          image: "services/mainContractor/crating.jpg",
          title: "Luxe Custom Crating Works",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 42,
          image: "services/mainContractor/metalRacking.jpg",
          title: "Luxe Custom Metal Racking System Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 43,
          image: "services/mainContractor/marbleStone.jpg",
          title: "Luxe Custom Marble Stone Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 44,
          image: "services/mainContractor/quartzStone.jpg",
          title: "Luxe Custom Quart Stone & Solid Surface Work",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
        {
          id: 45,
          image: "services/mainContractor/customP3.png",
          title:
            "Luxe Custom P3,p4,p5 64amp High Resolution Flexible Led Screen system",
          subTitle:
            "A luxury design desireable in door rooms with all high end first class bunglo design over Malaysia",
        },
      ],
    },
  ],
};

export const aboutUs = [
  {
    id: 1,
    title: "ABOUT US",
    desc: "Welcome to LUXE, a premier interior fitting firm founded in 2015, proudly serving clients across Malaysia. We specialize in transforming spaces through innovative interior design, making us one of the experienced interior design companies in the region. \n\nOur mission is to bring your vision to life. Whether you’re looking for custom interior fitting firms, a commercial contractor, or a reliable fit-out company, our skilled team is here to help. We focus on delivering exceptional results for both residential and commercial projects, ensuring every space reflects your unique style and needs.",
    img: "img_1.jpeg",
  },
  {
    id: 2,
    title: "OUR EXPERTISE",
    desc: "<b>Design & Build</b> \nA seamless process from concept to completion, ensuring quality at every step. \n\n<b>Commercial Interior Design</b> \nCrafting functional, inspiring environments that elevate your business. \n\n<b>Corporate Interior Design</b> \nDesigning modern workspaces that enhance collaboration and productivity. \n\n<b>Renovation Company</b> \nTransforming homes with tailored renovations to fit your lifestyle. \n\n<b>ID Contractors</b> \nProviding expert craftsmanship and attention to detail in all our projects. \n\nAt LUXE we pride ourselves on being one of the best interior design companies. Our commitment to excellence, creativity, and customer satisfaction sets us apart. \n\nLet us partner with you to create beautiful, functional spaces. Discover the LUXE difference today!",
    img: "img_4.jpeg",
  },
];
